exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.qa[data-v-56658e37] {\n  background-color: #333132;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-56658e37","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sectionQuestion/Question.vue
// module id = 368
// module chunks = 0